import { render } from "./CollectionBlock.vue?vue&type=template&id=002d22e8&scoped=true&ts=true"
import script from "./CollectionBlock.vue?vue&type=script&lang=ts"
export * from "./CollectionBlock.vue?vue&type=script&lang=ts"

import "./CollectionBlock.vue?vue&type=style&index=0&id=002d22e8&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002d22e8"]])

export default __exports__